/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DimensionListResponse } from './dimensionListResponse';


export interface DataCubeInfoResponse { 
    dataSourceName?: string;
    descriptionEn?: string;
    descriptionSk?: string;
    dimensions?: Array<DimensionListResponse>;
    frequencyCode?: string;
    zonation?: Array<string>;
    zonationEn?: Array<string>;
    lastDataChange?: string;
    lastStructureChange?: string;
    nameEn?: string;
    nameSk?: string;
    productCode?: string;
    publicId?: string;
    jpbdUploadType?: DataCubeInfoResponse.JpbdUploadTypeEnum;
    timePeriodFrom?: string;
    timePeriodTo?: string;
    updated?: boolean;
}

export namespace DataCubeInfoResponse {
    export type JpbdUploadTypeEnum = 'DATABASE' | 'FILE';
    export const JpbdUploadTypeEnum = {
        Database: 'DATABASE' as JpbdUploadTypeEnum,
        File: 'FILE' as JpbdUploadTypeEnum
    };
}
